const GlobalAlerts = require('../functions/GlobalAlerts');
const EtapaAprovacaoInput = require('./EtapaAprovacaoInput');
const GrupoAprovadorInput = require('./GrupoAprovadorInput');

function FluxosAprovacaoEvents() {
  const idFluxoAprovacao = $('#idAprovacaoFluxo').val();
  const usuarios = [];

  if(!idFluxoAprovacao) {
    EtapaAprovacaoInput('#formFluxo');
    GrupoAprovadorInput('#grupos-aprovadores-1');

    $('#grupos-aprovadores-1 + .add-grupo').trigger('click');

    return;
  }

  Promise.all([getFluxo(idFluxoAprovacao), getUsers(idFluxoAprovacao)])
    .then(function(responses) {
      // Response 0 = Fluxo de aprovação
      // Response 1 = Usuários do fluxo
      EtapaAprovacaoInput('#formFluxo', responses[0], responses[1]);
    })
    .catch((e) => {
      GlobalAlerts.createAndShow({
        type: 'danger',
        title: Lang.get('js/common/phrases.ops'),
        message: Lang.get('js/common/phrases.unexpected_error'),
      })
    });
}

function getFluxo(idFluxoAprovacao) {
  return Promise.resolve($.get(route('app.settings.fluxos-aprovacao.show', {
    fluxos_aprovacao: idFluxoAprovacao
  })));
}

function getUsers(idFluxoAprovacao) {
  return Promise.resolve($.get(route('app.settings.fluxos-aprovacao.usuarios', {
    fluxos_aprovacao: idFluxoAprovacao
  })));
}

module.exports = {
  url: /^\/settings\/fluxos-aprovacao\/(create|\d+\/edit)$/,
  init: FluxosAprovacaoEvents
}
